import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import {
	GameDevelopersContext,
	IGameDevelopersContext,
} from 'modules/Entertainment/Games/GameDevelopers/gameDevelopersState/gameDevelopersContext';
import style from './CreateBtn.module.scss';

const CreateBtn: React.FC = () => {
	const { changeTypeOfModalWindow } = useContext<IGameDevelopersContext>(GameDevelopersContext);

	const handleRedirect = () => {
		changeTypeOfModalWindow('createDeveloper');
	};

	return (
		<Button
			className={style.btn}
			theme="primaryBlue"
			data-test="CreateBtn"
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}
			onClick={handleRedirect}>
			<Text translationNameSpace="listing" translationKey="addDeveloperButton" asFragment={true} />
		</Button>
	);
};

export default CreateBtn;
